import { render, staticRenderFns } from "./PartnerContractInfo.vue?vue&type=template&id=5ca16397&scoped=true"
import script from "./PartnerContractInfo.vue?vue&type=script&lang=js"
export * from "./PartnerContractInfo.vue?vue&type=script&lang=js"
import style0 from "./PartnerContractInfo.vue?vue&type=style&index=0&id=5ca16397&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca16397",
  null
  
)

export default component.exports